import { memo } from 'react';
import { DROPS_FILTERS_LIST, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import { useDropEventListFiltersContext } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
export const DropsListFilter = memo(({ availableFilters }) => {
    const { filter, onFilterChange } = useDropEventListFiltersContext();
    const filtersList = useDropFiltersList(availableFilters);
    return (<ul role="list" className="flex justify-center sm:justify-start flex-wrap gap-3 sm:gap-2">
			{filtersList.map((option) => {
            const isActive = option.value === filter;
            return (<li key={option.value}>
						<button type="button" onClick={() => onFilterChange(option.value)}>
							<DropFilterBadge isActive={isActive}>{option.title}</DropFilterBadge>
						</button>
					</li>);
        })}
		</ul>);
});
const useDropFiltersList = (availableFilters) => {
    return DROPS_FILTERS_LIST.filter((option) => {
        return availableFilters.includes(option.value);
    });
};
export const DropFilterBadge = memo((props) => {
    const { isActive, children } = props;
    return (<Badge data-active={isActive} className="capitalize data-[active=true]:motion-safe:animate-slide-up hover:brightness-100 motion-safe:duration-150 bg-primary brightness-50 data-[active=true]:brightness-100">
			{children}
		</Badge>);
});
